import React, { Component } from 'react';
import { AppProps } from './AppState';


export const ErrorOccurred = (appProps: AppProps) => 
 
    (<div>
        <section className="theme-dark-gray">
              <div className="row">
                  <div className="form-group col-md-offset-1 col-md-10">
                      <h2>Ouch, something unexpected happened. Please try again in a few mins. If this problem continues, please contact support.</h2>
                  </div>
              </div>
        </section>
    </div>);

